// extracted by mini-css-extract-plugin
module.exports = {"background":"home_background__3-MPw","rellax":"home_rellax__26dxa rellax"};